function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "19",
  height: "24",
  viewBox: "0 0 19 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-phase-planung",
  transform: "translate(-3)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "planung",
  transform: "translate(3)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.05 22.75c0-.25.1-.86.27-.86l11.12.01c.17 0 .29.61.29.87 0 .29-.12.86-.29.86-.6 0-5.65-.01-11.12-.02-.18-.38-.27-.67-.27-.86z",
  id: "a3idsNi29X",
  fill: "#CF0A7D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.35 5.91C7.59 7.15 1.46 17.02.7 18.26c-.08.12-.13.26-.14.4-.04.49-.38 4.36-.42 4.85-.01.1.03.19.12.24.08.06.18.06.27.01.41-.26 3.72-2.26 4.13-2.52a.67.67 0 00.3-.3c.77-1.23 6.89-11.11 7.66-12.34.07-.13.05-.23-.07-.31-.26-.16-1.56-.98-3.9-2.45-.15-.03-.25-.01-.3.07z",
  id: "eXIsImx7X",
  fill: "#CF0A7D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.12 4.56l-1.48 2.38c-.08.13-.18.15-.3.07-.39-.24-3.5-2.21-3.89-2.45-.13-.08-.15-.18-.07-.3.15-.24 1.33-2.15 1.48-2.39.81-1.31 1.71-1.52 3.01-.7.06.04.24.07 1.03.7.8.63 1.03 1.38.22 2.69z",
  id: "aoov0EjIz",
  fill: "#CF0A7D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.87 21.25c.01-.18.1-1.11.24-2.79.44-.06.68-.09.72-.1.23-.03.3.01.38.23.03.06.21.54.23.6.09.22.2.37.36.47.14.09.33.13.56.11.07-.01.58-.05.65-.05.22-.02.29.02.36.24.02.05.09.28.23.7l-2.38 1.47c-.61-.5-1.06-.79-1.35-.88z",
  id: "dVZ4H2RkU",
  fill: "#FFF"
}))))));